import { useNavigate, useSearchParams } from "react-router-dom";
import { Plus } from "lucide-react";
import { PageHeader } from "@/components/app/Common";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from "@/lib/auth";
import { STAFF } from "@/lib/nav";
import { InviteTracker } from "@/pages/assessments/InviteTracker";
import { LibraryGrid } from "@/pages/assessments/library/LibraryGrid";
import { useMiniTour } from "@/components/app/miniTours";

export default function AssessmentsPage() {
  const nav = useNavigate();
  const [params, setParams] = useSearchParams();
  const { user } = useAuth();
  const staff = STAFF.includes(user.role);
  const tab = params.get("tab") || "library";
  useMiniTour("library", tab === "library");
  return (
    <div className="space-y-6" data-testid="assessments-page">
      <PageHeader title="Assessments"
        subtitle="Build the questionnaires candidates take, attach one to each job, then follow who has finished."
        actions={staff && <Button onClick={() => nav("/app/assessments/new")} data-testid="create-assessment-btn" data-tour="create-assessment"><Plus size={16} /> Create assessment</Button>} />
      <Tabs value={tab} onValueChange={(v) => setParams({ tab: v })}>
        <TabsList data-testid="assessments-tabs">
          <TabsTrigger value="library" data-testid="tab-library">My assessments</TabsTrigger>
          <TabsTrigger value="tracker" data-testid="tab-tracker">Tracker</TabsTrigger>
        </TabsList>
        <TabsContent value="library" className="pt-4"><LibraryGrid staff={staff} /></TabsContent>
        <TabsContent value="tracker" className="pt-4"><InviteTracker url="/assessments" queryKey={["assessments"]} showJob /></TabsContent>
      </Tabs>
    </div>
  );
}
